// import { stopVoiseLisenerAll,stopVoiseSpeecAll } from "./LitlModules";
// import elemScroll from "./elemScroll";
let mySound;
const voiceQuestion = (key, selLocal, viosPath, openAll, p) => {
	let audio_butto = document.getElementById('voise_aa' + key),
		curtiem;

	mySound && pauseVid(mySound);
	mySound = new Audio(viosPath);

	// console.log(audio_butto);
	const recognizer = global.recog;
	// console.log(mySound);
	// console.log(key);
	// console.log('.progress__bar'+key);
	// console.log(selLocal);
	// console.log(viosPath);
	// console.log(openAll);
	// console.log(p);

	// document.getElementsByClassName('progress__bar'+key)[0].addEventListener('click', setProgress);

	function setProgress(e) {
		const width = this.clientWidth,
			clickX = e.offsetX,
			duration = mySound.duration;
		curtiem = (clickX / width) * duration;
		mySound.currentTime = (clickX / width) * duration;
	}

	mySound.ontimeupdate = function (e) {
		myFunction(e);
	};
	function myFunction(e) {
		// console.log(e);
		if (!document.querySelector('.progress__current' + key)) return;
		const { duration, currentTime } = e.srcElement,
			progressPercent = (currentTime / duration) * 100;
		document.querySelector(
			'.progress__current' + key
		).style.width = `${progressPercent}%`;
	}

	function playVid(track, audio_button) {
		//  console.log(audio_button);
		// console.log(track.readyState);
		// recognizer.stop();
		track.play();

		track.onplay = function () {
			// alert("The video has started to play");
			audio_button.classList.remove('audio_play');
			audio_button.classList.add('audio_pause');
		};

		track.onpause = function () {
			curtiem = track.currentTime;
		};

		track.onended = function () {
			// console.log("The audio has ended function axmedet");
			audio_button.classList.remove('audio_pause');
			audio_button.classList.add('audio_play');
			track.currentTime, (curtiem = 0);
			let NoneStopMode = document
				.querySelector('#non_stop_mode_icon')
				.classList.contains('icon-material_tw_NonStop');
			if (NoneStopMode) {
				// recognizer.stop();
				// let time = setTimeout(() => {
				//   // startVoise();
				//   clearTimeout(time);
				// }, 900);
			}
		};

		track.ontimeupdate = function (e) {
			myFunction(e);
		};
		// function myFunction(e) {
		//   // console.log(e);
		//   if(!document.querySelector(progress__current)) return
		//     const { duration, currentTime } = e.srcElement;
		//     const progressPercent = (currentTime / duration) * 100;
		//     document.querySelector(progress__current).style.width = `${progressPercent}%`;
		// }
	}
	function pauseVid(track, audio_button) {
		track.pause();
		document.querySelectorAll('.audioTag').forEach(item => {
			if (item.classList.contains('audio_pause')) {
				item.classList.remove('audio_pause');
				item.classList.add('audio_play');
			}
		});
		document.getElementById('voise_aa' + key).classList.remove('audio_pause');
		document.getElementById('voise_aa' + key).classList.add('audio_play');
		// console.log('вызвался');
	}

	// if(global.appleMode) {
	//   console.log('lol');
	// } else {
	// }
	// setListeerBtnPlay();
	// if (!openAll) {
	//   let btnVoiseMute = document.querySelector('#voise_mudte_icon').classList.contains('icon-material_li_mute');
	//   if(!btnVoiseMute) {
	//     recognizer.stop();
	//     playVid(mySound);
	//   }
	//   elemScroll(selLocal);
	// }
	///////////////////////////////////////////////////////
	//   async function waitForElement() {
	//   while (true) {
	//     // console.log('llll');
	//     const element = document.getElementById('voise_aa'+key);
	//     // console.log('#voise_aa'+key);
	//     // console.log(seler+'question'+counter);
	//     // console.log(element);
	//     if (element) {
	//       console.log('Элемент найден', element);

	//       // Далее можно выполнить действия с найденным элементом
	//       return element;
	//     }
	//     await new Promise(resolve => setTimeout(resolve, 1000)); // Интервал проверки, в миллисекундах
	//   }
	// }
	// async function main() {
	//   var element = await waitForElement();
	//   console.log('Продолжение выполнения кода', element);
	//   let audio_butto = document.getElementById('voise_aa'+key);

	//   // Дальнейшие действия с найденным элементом
	//   // return true;
	//   // setListeerBtnPlay(audio_butto);
	//   // if (!openAll) {
	//   //   let btnVoiseMute = document.querySelector('#voise_mudte_icon').classList.contains('icon-material_li_mute');
	//   //   if(!btnVoiseMute) {
	//   //     recognizer.stop();
	//   //     playVid(mySound);
	//   //   }
	//   //   elemScroll(selLocal);
	//   // }

	// }

	// let key = counter;

	// main();

	function setListeerBtnPlay() {
		const audio_button = document.getElementById('voise_aa' + key);
		// console.log(key);
		if (!openAll) {
			let btnVoiseMute = document
				.querySelector('#voise_mudte_icon')
				.classList.contains('icon-material_li_mute');
			if (!btnVoiseMute) {
				recognizer.stop();
				//     playVid(mySound);
				mySound && pauseVid(mySound);
				mySound = new Audio(viosPath);

				playVid(mySound, audio_button);
			}
		}
		audio_button.addEventListener('click', e => {
			e.preventDefault();
			if (audio_button.classList.contains('audio_play')) {
				// mySound && mySound.pause();
				mySound && pauseVid(mySound);
				mySound = new Audio(viosPath);

				if (curtiem) {
					mySound.currentTime = curtiem;
					curtiem = null;
				}

				playVid(mySound, audio_button);
			} else {
				pauseVid(mySound, audio_button);
			}
		});
	}
	document
		.getElementsByClassName('progress__bar' + key)[0]
		.addEventListener('click', setProgress);
	// console.log(document.getElementsByClassName('progress__bar'+key)[0]);
	// console.log('progress__bar'+key);

	setListeerBtnPlay();
};
export default voiceQuestion;
